export default __webpack_public_path__ + "static/media/23.9e3f619a.png";